export default {
  get_all: { method: "get", url: "api/planos-exitos" },
  get_all_periodic: { method: "get", url: "api/plano-periodicidades" },
  store_periodic: { method: "post", url: "api/plano-periodicidades" },
  update_periodic: { method: "put", url: "api/plano-periodicidades{/id}" },
  delete_periodic: { method: "delete", url: "api/plano-periodicidades{/id}" },
  show: { method: "get", url: "api/planos-exitos{/id}" },
  store: { method: "post", url: "api/planos-exitos" },
  update: { method: "put", url: "api/planos-exitos{/id}" },
  delete: { method: "delete", url: "api/planos-exitos{/id}" },
};
